"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultSubject = exports.getMessageShadowText = exports.getMessageText = exports.getMessageShadowSubject = exports.getMessageSubject = exports.getTemplateId = exports.getTemplateName = exports.getIsMessageDraft = exports.getIsMessageSaved = exports.getPreviewUrl = exports.getMessageState = exports.getIsMessageLoading = void 0;

var _ramda = require("ramda");

var pathToMessage = (0, _ramda.path)(['createGift', 'postcard', 'message']);
var getIsMessageLoading = (0, _ramda.compose)((0, _ramda.prop)('isLoading'), pathToMessage);
exports.getIsMessageLoading = getIsMessageLoading;
var getMessageState = (0, _ramda.compose)((0, _ramda.prop)('state'), pathToMessage);
exports.getMessageState = getMessageState;
var getPreviewUrl = (0, _ramda.compose)((0, _ramda.prop)('previewUrl'), pathToMessage);
exports.getPreviewUrl = getPreviewUrl;
var getIsMessageSaved = (0, _ramda.compose)((0, _ramda.prop)('isSaved'), pathToMessage);
exports.getIsMessageSaved = getIsMessageSaved;
var getIsMessageDraft = (0, _ramda.compose)((0, _ramda.prop)('isDraft'), pathToMessage);
exports.getIsMessageDraft = getIsMessageDraft;
var getTemplateName = (0, _ramda.compose)((0, _ramda.prop)('templateName'), pathToMessage);
exports.getTemplateName = getTemplateName;
var getTemplateId = (0, _ramda.compose)((0, _ramda.prop)('templateId'), pathToMessage);
exports.getTemplateId = getTemplateId;
var getMessageSubject = (0, _ramda.compose)((0, _ramda.prop)('subject'), pathToMessage);
exports.getMessageSubject = getMessageSubject;
var getMessageShadowSubject = (0, _ramda.compose)((0, _ramda.prop)('shadowSubject'), pathToMessage);
exports.getMessageShadowSubject = getMessageShadowSubject;
var getMessageText = (0, _ramda.compose)((0, _ramda.prop)('text'), pathToMessage);
exports.getMessageText = getMessageText;
var getMessageShadowText = (0, _ramda.compose)((0, _ramda.prop)('shadowText'), pathToMessage);
exports.getMessageShadowText = getMessageShadowText;
var getDefaultSubject = (0, _ramda.compose)((0, _ramda.prop)('defaultSubject'), pathToMessage);
exports.getDefaultSubject = getDefaultSubject;